import { Trans } from '@/components'
import { Dropdown } from '@/components/base'
import { MachineType } from '@/consts/machine'

const workloadOptions = [
  { label: 'Training GPU', value: MachineType.TRAINING_GPU },
  { label: 'Inference GPU', value: MachineType.INFERENCE_GPU },
  { label: 'Render GPU', value: MachineType.RENDER_GPU },
]

interface WorkloadTypeSelectorProps {
  value: (string | number)[]
  onChange: (value: (string | number)[]) => void
}

export function WorkloadTypeSelector({ value, onChange }: WorkloadTypeSelectorProps) {
  return (
    <div className="flex flex-col gap-2">
      <div className="text-secondary t-sb">
        <Trans i18nKey="create.workloadTypeLabel">Workload Type</Trans>
      </div>
      <Dropdown
        multiple
        showAllOption
        options={workloadOptions}
        value={value}
        onChange={(values) => onChange(values as (string | number)[])}
        placeholder="Select workload types"
        rootClassName="w-[180px]"
      />
    </div>
  )
}
